/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipFileApprovalStudentsFilterViewModel } from "../types/ScholarshipFileApprovalStudentsFilterViewModel.ts";

export const scholarshipFileApprovalStudentsFilterViewModelSchema = z.object({
  classStudentIds: z
    .array(z.number().int())
    .describe("IDs das turmas a filtrar. No legado chegava como CSV. Opcional.")
    .nullish(),
  personId: z
    .number()
    .int()
    .describe(
      "ID do aluno. Quando informado, os demais filtros e o status geral da documentação são ignorados. Opcional.",
    )
    .nullish(),
  scholarshipTypeIds: z
    .array(z.number().int())
    .describe(
      "IDs dos tipos de bolsa a filtrar. No legado chegava como CSV. Opcional.",
    )
    .nullish(),
  email: z
    .string()
    .describe(
      "E-mail exato do aluno. A comparação ignora maiúsculas e minúsculas. Opcional.",
    )
    .nullish(),
  cpf: z
    .string()
    .describe(
      "CPF do aluno. Pontos e hífens são desconsiderados na comparação. Opcional.",
    )
    .nullish(),
  enrollmentStatusId: z
    .number()
    .int()
    .describe(
      "Status de matrícula a filtrar. Opcional. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
    )
    .nullish(),
  hasAnyFilter: z.optional(
    z
      .boolean()
      .describe(
        "Somente leitura. Indica se ao menos um dos seis filtros foi informado — é obrigatório informar pelo menos um.",
      ),
  ),
}) as unknown as ToZod<ScholarshipFileApprovalStudentsFilterViewModel>;
